export default function ToastStack({ toasts, onClose }) {
  if (!toasts?.length) return null;

  return (
    <div className="adc-toastStack" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`adc-toast adc-toast--${t.type || "info"}`}>
          <div className="adc-toast__body">
            <div className="adc-toast__title">{t.title}</div>
            {t.message ? <div className="adc-toast__msg">{t.message}</div> : null}
          </div>

          <button
            className="adc-toast__close"
            onClick={() => onClose(t.id)}
            aria-label="Cerrar notificación"
            type="button"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}

